/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ range: NonNullable<unknown>, name: NonNullable<unknown> }} Wrapped_Period_Share_TopInputs */

const en_us2_wrapped_period_share_top = /** @type {(inputs: Wrapped_Period_Share_TopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`My most trained exercise in ${i?.range}: ${i?.name}. My Pocket Gym.`)
};

const pt_br2_wrapped_period_share_top = /** @type {(inputs: Wrapped_Period_Share_TopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meu exercício mais treinado em ${i?.range}: ${i?.name}. My Pocket Gym.`)
};

const es_419_wrapped_period_share_top = /** @type {(inputs: Wrapped_Period_Share_TopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mi ejercicio más entrenado en ${i?.range}: ${i?.name}. My Pocket Gym.`)
};

const pt_pt2_wrapped_period_share_top = /** @type {(inputs: Wrapped_Period_Share_TopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O meu exercício mais treinado em ${i?.range}: ${i?.name}. My Pocket Gym.`)
};

const fr_fr2_wrapped_period_share_top = /** @type {(inputs: Wrapped_Period_Share_TopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mon exercice le plus travaillé en ${i?.range} : ${i?.name}. My Pocket Gym.`)
};

const de_de2_wrapped_period_share_top = /** @type {(inputs: Wrapped_Period_Share_TopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Meine meisttrainierte Übung in ${i?.range}: ${i?.name}. My Pocket Gym.`)
};

const it_it2_wrapped_period_share_top = /** @type {(inputs: Wrapped_Period_Share_TopInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il mio esercizio più allenato in ${i?.range}: ${i?.name}. My Pocket Gym.`)
};

/**
* | output |
* | --- |
* | "My most trained exercise in {range}: {name}. My Pocket Gym." |
*
* @param {Wrapped_Period_Share_TopInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_share_top = /** @type {((inputs: Wrapped_Period_Share_TopInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Share_TopInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_share_top(inputs)
	if (locale === "es-419") return es_419_wrapped_period_share_top(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_share_top(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_share_top(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_share_top(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_share_top(inputs)
	return en_us2_wrapped_period_share_top(inputs)
});
export { wrapped_period_share_top as "wrapped-period.share_top" }